import ButtonPrimary from "components/Button/ButtonPrimary";
import Input from "components/Input/Input";
import Label from "components/Label/Label";
import React, {useEffect, useState} from "react";
import {auth, db} from "configs/firebase-config";
import {
  EmailAuthProvider,
  fetchSignInMethodsForEmail,
  reauthenticateWithCredential,
  updateEmail,
  updatePassword, updateProfile
} from "firebase/auth";
import {collection, doc, getDocs, onSnapshot, query, updateDoc, where} from "firebase/firestore";
import hidepwd from "../../images/hide-password.svg";
import showpwd from "../../images/show-password.svg";
import {displayToast, toastType} from "../../global/Functions";

const DashboardEditProfile = () => {
  let updateObject = {};
  const user = auth.currentUser;
  const [email, setEmail] = useState("");
  const [native, setNative] = useState<boolean>();
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [userName, setUserName] = useState("");
  const [defaultEmail, setDefaultEmail] = useState("");
  const [defaultLastName, setDefaultLastName] = useState("");
  const [defaultFirstName, setDefaultFirstName] = useState("");
  const [defaultUserName, setDefaultUserName] = useState<any>("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordConfirmShown, setPasswordConfirmShown] = useState(false);

  useEffect(() => {
    const unsubscribe = onSnapshot(doc(db, "users", `${auth.currentUser?.uid}`), (result) => {
      setDefaultFirstName(result.get("firstName"));
      setDefaultLastName(result.get("lastName"));
      setDefaultEmail(result.get("email"));
      setDefaultUserName(auth.currentUser?.displayName);
    })

    fetchSignInMethodsForEmail(auth, user?.email as string).then((methods) => {
      methods[0] === "password" ? setNative(true) : setNative(false)
    });

    return () => {unsubscribe()}
  }, [])

  const handleSubmit = async (e: any) => {
    const userDocRef = doc(db, "users", `${auth.currentUser?.uid}`);
    e.preventDefault();
    if (user) {
      if (email !== "" && email !== defaultEmail) {
        await updateEmail(user, email).then(() => {
          updateObject = {email, ...updateObject}
        }).catch((error) => {
          displayToast(error.code, toastType.error);
        })
      }
      if (firstName !== "" && firstName != defaultFirstName) {
        updateObject = {firstName, ...updateObject}
      }
      if (lastName !== "" && lastName != defaultLastName) {
        updateObject = {lastName, ...updateObject}
      }
      if (currentPassword !== "" && newPassword !== "") {
        // updatePassword()
        const credential = EmailAuthProvider.credential(defaultEmail, currentPassword);
        await reauthenticateWithCredential(user, credential).then(async () => {
          await updatePassword(user, newPassword).then(() => {
            setCurrentPassword("");
            setNewPassword("");
            displayToast("Password successfully updated", toastType.success)
            e.target.reset();
          }).catch((error) => {
            displayToast(error.code, toastType.error);
          });
        }).catch((error) => {
          displayToast(error.code, toastType.error);
        });
      }
      if (userName !== "" && userName != defaultUserName) {
        await updateProfile(user, {displayName: userName})
        updateObject = {displayName: userName, ...updateObject}
      }
      await updateDoc(userDocRef, {...updateObject});
    }
    e.target.reset();
  }
  return (
    <div className="rounded-xl md:border md:border-neutral-100 dark:border-neutral-800 md:p-6">
      <form className="grid md:grid-cols-2 gap-6" method="POST" onSubmit={handleSubmit}>
        <label className="block">
          <Label>First name</Label>
          <Input placeholder="First Name" defaultValue={defaultFirstName} type="text" className="mt-1"
                 onChange={(e) => setFirstName(e.target.value)}/>
        </label>
        <label className="block">
          <Label>Last name</Label>
          <Input placeholder="Last Name" defaultValue={defaultLastName} type="text" className="mt-1"
                 onChange={(e) => setLastName(e.target.value)}/>
        </label>
        {native &&
          <>
            <div className={"pwd-container"} style={{position: "relative"}}>
              <label className="block">
                <Label>Current password</Label>
                <Input
                  type={passwordShown ? "text" : "password"}
                  placeholder={passwordShown ? "password" : "**********"}
                  className="mt-1"
                  onChange={(e) => setCurrentPassword(e.target.value)}
                />
                <img
                  title={passwordShown ? "Hide password" : "Show password"}
                  src={passwordShown ? hidepwd : showpwd}
                  onClick={() => {
                    setPasswordShown(!passwordShown)
                  }}
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    width: "1.5rem",
                    right: "1.25rem",
                    top: "2.5rem",
                    fill: "white"
                  }}
                  alt="Show/Hide Password"
                />
              </label>
            </div>
            <div className={"pwd-container"} style={{position: "relative"}}>
              <label className="block">
                <Label>New password</Label>
                <Input
                  type={passwordConfirmShown ? "text" : "Shhh! It's a secret..."}
                  placeholder={passwordConfirmShown ? "New Password" : "**********"}
                  className="mt-1"
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <img
                  title={passwordConfirmShown ? "Hide password" : "Show password"}
                  src={passwordConfirmShown ? hidepwd : showpwd}
                  onClick={() => {
                    setPasswordConfirmShown(!passwordConfirmShown)
                  }}
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    width: "1.5rem",
                    right: "1.25rem",
                    top: "2.5rem",
                    fill: "white"
                  }}
                  alt="Show/Hide Password"
                />
              </label>
            </div>
          </>
        }
        <label className="block">
          <Label>Username</Label>
          <Input placeholder="Last Name" defaultValue={defaultUserName} type="text" className="mt-1"
            onChange={(e) => setUserName(e.target.value)}
            onBlur={async (event) => {
             const q = query(
               collection(db, "users"),
               where("displayName", "==", event.target.value)
             );
             const match = await getDocs(q);
             if (match.size >= 1) {
               displayToast("Username Taken", toastType.warn)
               event.target.value = "";
             } else {
               setUserName(event.target.value);
             }
            }}
          />
        </label>
        <label className="block md:col-span-2">
          <Label> Email address</Label>
          <Input
            type="email"
            defaultValue={defaultEmail}
            placeholder="name@example.com"
            className="mt-1"
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <ButtonPrimary className="md:col-span-2" type="submit">
          Update profile
        </ButtonPrimary>
      </form>
    </div>
  );
};

export default DashboardEditProfile;
